import { startTransition, useEffect, useState } from 'react';

const designers = [
  'Vico Magistretti',
  'Gae Aulenti',
  'Ingo Maurer',
  'Charlotte Perriand',
  'Alvar Aalto',
  'Ettore Sottsass',
  'Pierre Paulin',
  'Tadao Ando',
  'Ray Eames',
  'Zaha Hadid',
  'Isamu Noguchi',
  'Verner Panton',
  'Gino Sarfatti',
  'Yrjö Kukkapurro',
  'Gaetano Pesce',
  'Enzo Mari',
  'Richard Sapper',
];

export const usePlaceholder = (): {
  first: string;
  last: string;
  name: string;
  email: string;
} => {
  const [randomPlaceholder, setRandomPlaceholder] = useState<{
    first: string;
    last: string;
    name: string;
    email: string;
  }>({ first: '', last: '', name: '', email: '' });

  useEffect(() => {
    const name = designers[Math.floor(Math.random() * designers.length)];
    const [first, last] = name.split(' ');
    const email = `${first.replace('ö', 'o')}@${last}.com`.toLowerCase();

    startTransition(() => {
      setRandomPlaceholder({ first, last, name, email });
    });
  }, []);

  return randomPlaceholder;
};
